GameView = require "views/base/game"
Prefix = require("lib/prefix")
{ DraggyView }  = require("views/components/draggy")

class DialDistributionView extends GameView
  template: require("./template")

  events:
    "iostap .btn-done": "endGame"

  serialize: ->
    d = super

    d.values = _.chain(d.metadata.questions[0].answers)
      .filter((a) -> _.isNumber(a.content))
      .map (a) ->
        a.content = parseFloat(a.content) or 0
        a
      .sort((a, b) -> a.content - b.content)
      .value()

    d

  beforeShow: ->
    @distribution = @getDistribution()

    @setEl @findOne(".dial"), "dial"
    @setEl @findOne(".dial-knob-input"), "knob-input"
    @setEl @findOne(".dial-knob-input-value"), "knob-input-value"
    @setEl @findOne(".dial-knob-answer"), "knob-answer"
    @setEl @findOne(".dial-knob-answer-value"), "knob-answer-value"
    @setEl @findOne(".dial-knob-value"), "knob-value"
    @setEl @findAll(".dial-notch"), "notches"
    @setEl @findAll(".dial-label"), "labels"

    @rotateElements(@getEl("notches"))
    @rotateElements(@getEl("labels"))

  onRefresh: ->
    @beforeShow()
    super

  show: ->
    super

    el = @findOne(".content-fit")

    @draggy = new DraggyView
      el: @getEl("dial")
      radius: @getEl("dial").offsetWidth / 2
      isParent: true

    @listenTo @draggy, "drag", @onDrag
    @listenTo @draggy, "drop", @onDrop

    @enterGame()

  rotateElements: (elements) ->
    dir = if @options.config().direction is "rtl" then -1 else 1

    for el, i in elements
      @transform el,
        rotate: @distribution[i] * 360 * dir

  getDistribution: ->
    { values, distribution, overlap } = @serialize()

    min    = values[0].content
    max    = values[values.length - 1].content
    dist   = Math.abs(max - min)
    base   = Math.log(dist) * Math.log(dist)
    factor = if overlap then 1 else 1 - 1 / values.length

    for v, i in values
      switch distribution
        when "Equal"
          factor * i / (values.length - 1)
        when "Linear"
          factor * (v.content - min) / (dist)
        when "Logarithmic"
          d = Math.abs(v.content - min)
          if d is 0 then 0 else factor * (Math.log(d) * Math.log(dist)) / base

  onDrag: (draggy, isInitialDrag) ->
    @currentAnswer = @getSelectedAnswer(draggy)
    @currentValue = @currentAnswer.content
    @labelEl @getEl("knob-value"), @currentValue

    @transform @getEl("knob-input"),
      rotate: "#{draggy.t}rad"
      transition: if isInitialDrag then "all 300ms" else "none"

    @transform @getEl("knob-input-value"),
      x: "-50%"
      rotate: "#{-draggy.t}rad"
      transition: if isInitialDrag then "all 300ms" else "none"

  onDrop: (draggy, isReset) ->
    if not isReset
      draggy.reset({t: @roundPos(draggy)})
    else
      @currentAnswer = @getSelectedAnswer(draggy)
      @currentValue = @currentAnswer.content
      @labelEl @getEl("knob-value"), @currentValue

      @transform @getEl("knob-input"),
        rotate: "#{draggy.t}rad"
        transition: "all 300ms"

      @transform @getEl("knob-input-value"),
        x: "-50%"
        rotate: "#{-draggy.t}rad"
        transition: "all 300ms"

      if @currentValue?
        @setState("touched")

  getSelectedAnswer: (draggy) ->
    { values } = @serialize()
    percent = @roundPercent(draggy)
    index   = @distribution.indexOf(percent)
    index   = 0 if index is -1

    if @options.config().direction is "rtl"
      values[values.length - 1 - index]
    else
      values[index]

  roundPos: (draggy) ->
    (Math.PI * 2) * @roundPercent(draggy)

  roundPercent: (draggy) ->
    { values } = @serialize()

    length  = values.length
    percent = _.limit(draggy.t / (Math.PI * 2), 0, 1)

    _.nearest([1].concat(@distribution), percent)

  labelEl: (el, value) ->
    {prefix, suffix} = @options.data.dial

    value = @currentValue
    el.innerHTML = "#{prefix}#{value}#{suffix}"

  showAnswer: ->
    @animateAnswerKnob()
    @draggy.lock()

  isCorrect: ->
    @currentValue? and
    @currentValue is @options.data.dial.correct

  animateAnswerKnob: ->
    { dial, values }  = @serialize()

    correctIndex = _.findIndex(values, (v) -> v.correct)
    percent = @distribution[correctIndex]

    @transform @getEl("knob-answer"),
      rotate: "#{@draggy.t}rad"
      transition: "none"

    @transform @getEl("knob-answer-value"),
      x: "-50%"
      rotate: "-#{@draggy.t}rad"
      transition: "none"

    @getEl("knob-answer").offsetWidth

    @transform @getEl("knob-answer"),
      rotate: "#{percent * Math.PI * 2}rad"
      transition: if @draggy.locked then "none" else "all 600ms"

    @transform @getEl("knob-answer-value"),
      x: "-50%"
      rotate: "-#{percent * Math.PI * 2}rad"
      transition: if @draggy.locked then "none" else "all 600ms"

  answerDetails: ->
    question = @options.metadata?.questions?[0]

    return if question and @currentAnswer
      [{ question:question.question, answer: @currentAnswer }]
    else
      []

  endGame: ->
    super

    @submit()


module.exports = DialDistributionView
